export function isUnitService(service) {
    return service?.feeType === 'unit';
}